import React from 'react'
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {useIntl} from "react-intl";
import {NavLink} from "react-router-dom";
import {StyledTableCell, StyledTableRow} from "../../table/StyledTableSecondary.css";

const ScoredSceneStatusHistorySummary = ({statusInfo}) => {
    // Internationalization for simple strings
    const intl = useIntl();

    if (!statusInfo || statusInfo.history.length === 0) {
        return intl.formatMessage({
            id: 'app.scoredScene.statusHistory.noHistoryAvailableYet',
            defaultMessage: 'No history available yet'
        })
    }

    return <TableContainer>
        <TableContainer sx={{minWidth: 650}} size="small" aria-label="a dense table">
            <Table size="small">
                <TableHead>
                    <StyledTableRow>
                        <TableCell align="center">
                            {intl.formatMessage({
                                id: 'app.scoredScene.statusHistory.table.column.fromStatus',
                                defaultMessage: 'From'
                            })}
                        </TableCell>
                        <TableCell align="center">
                            {intl.formatMessage({
                                id: 'app.scoredScene.statusHistory.table.column.toStatus',
                                defaultMessage: 'To'
                            })}
                        </TableCell>
                        <TableCell align="center">
                            {intl.formatMessage({
                                id: 'app.scoredScene.statusHistory.table.column.comment',
                                defaultMessage: 'Comment'
                            })}
                        </TableCell>
                        <TableCell align="center">
                            {intl.formatMessage({
                                id: 'app.scoredScene.statusHistory.table.column.user',
                                defaultMessage: 'User'
                            })}
                        </TableCell>
                        <TableCell align="center">
                            {intl.formatMessage({
                                id: 'app.scoredScene.statusHistory.table.column.date',
                                defaultMessage: 'Date'
                            })}
                        </TableCell>
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {statusInfo?.history.map((hInfo, index) => (
                        <TableRow key={index}>
                            <StyledTableCell align="center">
                                {intl.formatMessage({
                                    id: `app.ids.scoredSceneStatus.${hInfo.fromStatus}`,
                                    defaultMessage: hInfo.fromStatus
                                })}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                {intl.formatMessage({
                                    id: `app.ids.scoredSceneStatus.${hInfo.toStatus}`,
                                    defaultMessage: hInfo.toStatus
                                })}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                                <div style={{whiteSpace: "pre-line", inlineSize: 400, overflowWrap: "break-word"}}>
                                    {hInfo.comment}
                                </div>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                <NavLink to={`/admin/users/${hInfo.uid}/edit`}>
                                    {hInfo.email}
                                </NavLink>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                {intl.formatDate(hInfo.date)}
                            </StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </TableContainer>
}
export default ScoredSceneStatusHistorySummary